import './App.css';
import { lazy, Suspense } from 'react';
import DrawerAppBar from './components/drawer-app-bar/drawer-app-bar.component';
import { Route, Routes } from 'react-router';
import Footer from './components/footer/footer.component';
import ScrollToTop from './components/scroll-to-top/ScrollToTop.component';
import { CircularProgress, Box } from '@mui/material';

const Home = lazy(() => import('./routes/home/home.page').then(m => ({ default: m.Home })));
const AboutUs = lazy(() => import('./routes/about-us/about-us.page'));
const Products = lazy(() => import('./routes/products/products.page').then(m => ({ default: m.Products })));
const Main = lazy(() => import('./routes/products/main/products.page').then(m => ({ default: m.Main })));
const Tubular = lazy(() => import('./routes/products/tubular/tubular.page').then(m => ({ default: m.Tubular })));
const Flat = lazy(() => import('./routes/products/flat/flat.page').then(m => ({ default: m.Flat })));
const Other = lazy(() => import('./routes/products/other/other.page').then(m => ({ default: m.Other })));
const NotFound = lazy(() => import('./routes/not-found/not-found.page'));

const Loading = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
    <CircularProgress />
  </Box>
);

function App() {
  return (
    <div className="App">
      <DrawerAppBar />
      <div className='content'>
        <ScrollToTop />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home/*" element={<Home />} />
            <Route path="/about-us/*" element={<AboutUs />} />
            <Route path="/products/*" element={<Products />}>
              <Route path="" element={<Main />} />
              <Route path="tubular" element={<Tubular />} />
              <Route path="flat" element={<Flat />} />
              <Route path="other" element={<Other />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </div>
  );
}

export default App;
